// extracted by mini-css-extract-plugin
export default {"container":"OrderForm_container__eds22","buttonSaveDraft":"OrderForm_buttonSaveDraft__rjOdg","buttonSendOrder":"OrderForm_buttonSendOrder__mwaeO"};